import { render, staticRenderFns } from "./bannerRight.vue?vue&type=template&id=1cdbbc56&scoped=true&"
import script from "./bannerRight.vue?vue&type=script&lang=ts&"
export * from "./bannerRight.vue?vue&type=script&lang=ts&"
import style0 from "./bannerRight.vue?vue&type=style&index=0&id=1cdbbc56&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdbbc56",
  null
  
)

export default component.exports